import { UIComponents } from './UIComponents.js';

export class ControlPanel {
    constructor(container, callbacks) {
        this.container = container;
        this.callbacks = callbacks || {};
        this.lightItems = [];
        this.elements = {};
        
        this.init();
    }

    init() {
        this.container.innerHTML = '';
        
        // Create header with toggle button
        this.createHeader();
        
        // Create content wrapper
        this.contentWrapper = document.createElement('div');
        this.contentWrapper.className = 'panel-content';
        this.container.appendChild(this.contentWrapper);
        
        // Black hole controls
        this.createBlackHoleControls();
        
        // Light source controls
        this.createLightSourceControls();
        
        // Camera presets
        this.createCameraPresets();
    }

    createHeader() {
        const header = document.createElement('div');
        header.className = 'panel-header';
        
        const title = document.createElement('span');
        title.textContent = 'Settings';
        title.className = 'panel-title';
        
        const toggleBtn = document.createElement('button');
        toggleBtn.className = 'panel-toggle-btn';
        toggleBtn.textContent = '−';
        toggleBtn.title = 'Minimize panel';
        
        toggleBtn.addEventListener('click', () => {
            const isMinimized = this.container.classList.toggle('minimized');
            toggleBtn.textContent = isMinimized ? '+' : '−';
            toggleBtn.title = isMinimized ? 'Maximize panel' : 'Minimize panel';
        });
        
        header.appendChild(title);
        header.appendChild(toggleBtn);
        this.container.appendChild(header);
    }

    createBlackHoleControls() {
        const title = document.createElement('h2');
        title.textContent = 'Black Hole';
        title.style.marginTop = '0';
        title.style.marginBottom = '16px';
        title.style.fontSize = '18px';
        this.contentWrapper.appendChild(title);
        
        // Mass slider
        const massControl = UIComponents.createSlider(
            'Mass',
            1,
            50,
            10,
            1,
            (value) => {
                if (this.callbacks.onMassChange) {
                    this.callbacks.onMassChange(value);
                }
            }
        );
        this.contentWrapper.appendChild(massControl.container);
        this.elements.massSlider = massControl.slider;
        
        this.contentWrapper.appendChild(document.createElement('hr'));
    }

    createLightSourceControls() {
        const title = document.createElement('h2');
        title.textContent = 'Light Sources';
        title.style.marginTop = '16px';
        title.style.marginBottom = '16px';
        title.style.fontSize = '18px';
        this.contentWrapper.appendChild(title);
        
        // Add light button
        const addButton = UIComponents.createButton('Add Light Source', () => {
            if (this.callbacks.onAddLight) {
                this.callbacks.onAddLight();
            }
        });
        this.contentWrapper.appendChild(addButton);
        
        // Light sources list container
        const lightsContainer = document.createElement('div');
        lightsContainer.id = 'lights-list';
        lightsContainer.style.marginTop = '12px';
        this.contentWrapper.appendChild(lightsContainer);
        this.elements.lightsContainer = lightsContainer;
        
        this.contentWrapper.appendChild(document.createElement('hr'));
    }

    createCameraPresets() {
        const title = document.createElement('h2');
        title.textContent = 'Camera';
        title.style.marginTop = '16px';
        title.style.marginBottom = '16px';
        title.style.fontSize = '18px';
        this.contentWrapper.appendChild(title);
        
        const presetsContainer = document.createElement('div');
        presetsContainer.className = 'camera-presets';
        
        const presets = [
            { name: 'Top', value: 'top' },
            { name: 'Side', value: 'side' },
            { name: 'Close-up', value: 'closeup' },
            { name: 'Diagonal', value: 'diagonal' }
        ];
        
        presets.forEach(preset => {
            const button = document.createElement('button');
            button.className = 'preset-button';
            button.textContent = preset.name;
            button.addEventListener('click', () => {
                if (this.callbacks.onCameraPreset) {
                    this.callbacks.onCameraPreset(preset.value);
                }
            });
            presetsContainer.appendChild(button);
        });
        
        this.contentWrapper.appendChild(presetsContainer);
    }

    addLightSourceItem(light, index) {
        const item = document.createElement('div');
        item.className = 'light-item';
        item.dataset.lightId = light.getId();
        
        const header = document.createElement('div');
        header.className = 'light-item-header';
        
        const title = document.createElement('div');
        title.className = 'light-item-title';
        title.textContent = `Light ${index + 1}`;
        
        const removeButton = document.createElement('button');
        removeButton.textContent = 'Remove';
        removeButton.addEventListener('click', () => {
            if (this.callbacks.onRemoveLight) {
                this.callbacks.onRemoveLight(light.getId());
            }
        });
        
        header.appendChild(title);
        header.appendChild(removeButton);
        item.appendChild(header);
        
        // Intensity slider
        const intensityControl = UIComponents.createSlider(
            'Intensity',
            0,
            50,
            light.getIntensity(),
            0.5,
            (value) => {
                if (this.callbacks.onLightIntensityChange) {
                    this.callbacks.onLightIntensityChange(light.getId(), value);
                }
            }
        );
        item.appendChild(intensityControl.container);
        
        // Color picker
        const colorControl = UIComponents.createColorPicker(
            'Color',
            light.getColor().getHex(),
            (value) => {
                if (this.callbacks.onLightColorChange) {
                    this.callbacks.onLightColorChange(light.getId(), value);
                }
            }
        );
        item.appendChild(colorControl.container);
        
        this.elements.lightsContainer.appendChild(item);
        this.lightItems.push({ element: item, light });
    }

    removeLightSourceItem(lightId) {
        const index = this.lightItems.findIndex(item => item.light.getId() === lightId);
        if (index !== -1) {
            this.lightItems[index].element.remove();
            this.lightItems.splice(index, 1);
        }
        
        // Renumber remaining lights
        this.lightItems.forEach((item, idx) => {
            const title = item.element.querySelector('.light-item-title');
            if (title) {
                title.textContent = `Light ${idx + 1}`;
            }
        });
    }

    updateMass(value) {
        if (this.elements.massSlider) {
            this.elements.massSlider.value = value;
            const valueDisplay = this.elements.massSlider.parentElement.querySelector('.value-display');
            if (valueDisplay) {
                valueDisplay.textContent = parseFloat(value).toFixed(2);
            }
        }
    }
}
